(function () {
  'use strict';
  var images = Array.from(document.querySelectorAll('main img[loading="lazy"]'));
  var queue = images.slice(), active = 0;
  var started = new WeakSet();

  function requestImage(img) {
    if (started.has(img) || (img.complete && img.naturalWidth)) return;
    started.add(img);
    active++;
    var tries = 0, timer, settled = false;
    var original = img.getAttribute('src');
    function finish() {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      img.removeEventListener('load', finish);
      img.removeEventListener('error', retry);
      active--;
      pump();
    }
    function retry() {
      clearTimeout(timer);
      if (tries >= 2) { finish(); return; }
      tries++;
      timer = setTimeout(function () {
        var url = new URL(original, location.href);
        url.searchParams.set('al_image_retry', String(tries));
        img.src = url.toString();
        timer = setTimeout(retry, 10000);
      }, tries * 400);
    }
    img.addEventListener('load', finish);
    img.addEventListener('error', retry);
    img.decoding = 'async';
    img.fetchPriority = 'low';
    img.loading = 'eager';
    timer = setTimeout(retry, 10000);
    if (img.complete) {
      if (img.naturalWidth) finish();
      else retry();
    }
  }
  function pump() {
    while (active < 2 && queue.length) requestImage(queue.shift());
  }
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        requestImage(entry.target);
      });
    }, { rootMargin: '1600px 0px' });
    images.forEach(function (img) { observer.observe(img); });
  }
  if ('requestIdleCallback' in window) requestIdleCallback(pump, { timeout: 1500 });
  else setTimeout(pump, 500);
}());
